import { isEmbeddedPersonalPanel } from '@opallabs/brown-dwarf'
import { Size } from '@opallabs/gem'
import {
  kuiperClassNames,
  ConnectedCurrentUserAvatar,
  Menu,
  PopoverV2,
} from '@opallabs/kuiper'
import { Icon } from '@opallabs/lapidary'
import * as styles from './styles'
import type { MenuOption, UserHeaderProps } from './types'

const menu: MenuOption[] = [
  { title: 'Edit My Settings', url: 'settings' },
  { title: 'Edit My Profile', url: 'profile' },
  { title: 'Privacy Policy', url: 'privacy_policy' },
  { title: 'Terms of Use', url: 'terms_of_use' },
  { title: 'Log out of Opal', url: 'logout' },
]

const UserHeader: React.FC<UserHeaderProps> = ({
  name,
  onClickClose,
  onMenuClick,
  theme = 'light',
}) => {
  const filteredMenuOptions = isEmbeddedPersonalPanel()
    ? menu.filter(
        (opt) => opt.url !== 'privacy_policy' && opt.url !== 'terms_of_use'
      )
    : menu

  return (
    <div css={styles.wrapperStyles({ theme })}>
      <div css={styles.leftWrapperStyles}>
        <ConnectedCurrentUserAvatar
          displayRole={false}
          size={66}
          theme={theme}
        />
        <div css={styles.textWrapperStyles}>
          <span css={styles.userNameStyles}>{name}</span>
        </div>
      </div>
      <div css={styles.rightWrapperStyles({ theme })}>
        <button
          aria-label="Close Personal Panel"
          css={styles.closeButtonStyles({ theme })}
          className={kuiperClassNames('control-button')}
          onClick={onClickClose}
        >
          <Icon
            ariaMode="hidden"
            glyph="gem-close"
            height={Size.Icon}
            width={Size.Icon}
          />
        </button>
        <PopoverV2
          content={
            <Menu<MenuOption>
              canSelectAll={false}
              onSelect={onMenuClick}
              options={filteredMenuOptions}
              role="menu"
              theme={theme}
            />
          }
          trigger={
            <button
              aria-label="Manage user account"
              css={styles.buttonStyles({ theme })}
              className={kuiperClassNames('control-button')}
            >
              <Icon
                ariaMode="hidden"
                glyph="gem-more-vertical"
                height={Size.Icon}
                width={Size.Icon}
              />
            </button>
          }
        />
      </div>
    </div>
  )
}
UserHeader.displayName = 'Darwin: UserHeader ← PersonalPanel'

export default UserHeader
